$(document).ready(function() {
  $('.video-ply').click(function() {
    
    let box = $('.hm-video-bx');

    if (box.css('right') === '0px') {
      // close
      box.animate({
        right: '100%'   
      }, 400);
    } else {
      // open
      box.animate({
        right: '0'
      }, 400);
    }

  });
});